import L from 'leaflet';

export default L.Control.extend({

  options: {
    locale: {
      expandMap: 'Expand map',
      collapseMap: 'Collapse map',
    },
    expandIcon: 'mdi-fullscreen',
    collapseIcon: 'mdi-fullscreen-exit',
  },

  enabled: false,
  btn: null,

  onAdd(map) {
    this.map = map;
    this.container = document.createElement('div');
    this.container.classList.add('leaflet-control', 'leaflet-bar');
    this.btn = this.createButton();
    return this.container;
  },

  onRemove() {
    if (this.btn) {
      this.btn.remove();
    }
  },

  createButton() {
    this.iconClass = this.enabled ? this.options.collapseIcon : this.options.expandIcon;
    const title = this.enabled ? this.options.locale.collapseMap : this.options.locale.expandMap;
    this.icon = document.createElement('i');
    this.icon.classList.add('v-icon', 'mdi', this.iconClass);
    const btn = document.createElement('a');
    this.container.appendChild(btn);
    btn.appendChild(this.icon);
    btn.href = '#';
    btn.title = title;
    btn.setAttribute('role', 'button');
    btn.setAttribute('aria-label', title);
    btn.addEventListener('click', () => { this.toggleFullscreen(); });
    L.DomEvent.disableClickPropagation(btn);
    return btn;
  },
  toggleFullscreen() {
    const mapContainer = this.map.getContainer();
    if (this.enabled) {
      const exitFullscreen = document.exitFullscreen
        || document.mozCancelFullScreen
        || document.webkitCancelFullScreen
        || document.msExitFullscreen;
      exitFullscreen.call(document);
      this.enabled = false;
    } else {
      const requestFullscreen = mapContainer.requestFullscreen
        || mapContainer.mozRequestFullScreen
        || mapContainer.webkitRequestFullScreen
        || mapContainer.msRequestFullScreen;
      requestFullscreen.call(mapContainer);
      this.enabled = true;
    }
    this.icon.classList.remove(this.options.collapseIcon, this.options.expandIcon);
    this.iconClass = this.enabled ? this.options.collapseIcon : this.options.expandIcon;
    this.icon.classList.add(this.iconClass);
    this.btn.title = this.enabled ? this.options.locale.collapseMap : this.options.locale.expandMap;
  },
});
